import { Controller } from "@hotwired/stimulus"

const SDK_URL = "https://sdk.mercadopago.com/js/v2"

export default class extends Controller {
  static targets = ["brick"]
  static values = { publicKey: String, preferenceId: String }

  connect() {
    if (!this.publicKeyValue || !this.preferenceIdValue) return

    this.loadSdk()
      .then(() => this.renderBrick())
      .catch((error) => this.reportFailure(error))
  }

  // A rejection here used to be dropped, leaving an empty container and no
  // hint of why: a public key from another application, a preference the
  // seller does not own and a blocked SDK all looked identical.
  reportFailure(error) {
    console.error("Mercado Pago checkout:", error)

    this.brickTarget.textContent = this.brickTarget.dataset.failureText || ""
  }

  disconnect() {
    if (this.controller) this.controller.unmount()
  }

  loadSdk() {
    if (window.MercadoPago) return Promise.resolve()

    const existing = document.querySelector(`script[src="${SDK_URL}"]`)
    if (existing) return new Promise((resolve) => existing.addEventListener("load", resolve, { once: true }))

    return new Promise((resolve, reject) => {
      const script = document.createElement("script")
      script.src = SDK_URL
      script.addEventListener("load", resolve, { once: true })
      script.addEventListener("error", reject, { once: true })
      document.head.appendChild(script)
    })
  }

  async renderBrick() {
    const mercadoPago = new window.MercadoPago(this.publicKeyValue, { locale: document.documentElement.lang || "pt-BR" })

    this.brickTarget.innerHTML = ""
    this.controller = await mercadoPago.bricks().create("wallet", this.brickTarget.id, {
      initialization: { preferenceId: this.preferenceIdValue }
    })
  }
}
